module.exports = __webpack_public_path__ + "img/drug_cert.fed9d84a.png";